// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"187":"component---src-pages-wedding-tsx","532":"styles","691":"component---src-pages-index-tsx"}[chunkId] || chunkId) + "-" + {"187":"ae0917bfe5ced05fc426","532":"471aa2f2c2bdc64521c2","691":"d20b17c50d83e614f922","731":"4e0657f1bf23f9f4ba64","843":"f44d9a37d28f1f0ac04f"}[chunkId] + ".js";
};